import { api } from '@/lib/api';
import type { IApiResponse, IRawDimTeam } from '@skystone/shared';

export const rawDimTeamApi = {
  getAll: async (): Promise<IRawDimTeam[]> => {
    const result = await api.get<IApiResponse<IRawDimTeam[]>>('/raw-dim-teams');
    return result.data;
  },
};
